import React, { Component } from 'react'
import styled from 'styled-components'
import { Modal, TextInput, DatePicker, Button } from 'advenio-components'
import { Form } from 'formsy-react' // eslint-disable-line
import moment from 'moment'

const InputsRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 8px 0 8px;
`

const InputContainer = styled.div`
  flex: 1;
  margin: ${props => props.fullWidth ? '0 16px 0 16px' : '0 8px 0 8px'}
`

const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 0 16px 0;
`

class AddAdjustmentModal extends Component {
  handleSubmit = (data) => {
    const { sendAdjustment, studentId } = this.props
    const infoToSend = { ...data }
    infoToSend.type = 'custom'
    infoToSend.date = moment(data.date, 'YYYY-MM-DD')
      .hour(moment().hour())
      .minute(moment().minute())
      .second(moment().second())
      .format('YYYY-MM-DD HH:mm:SS')

    sendAdjustment(studentId, infoToSend)
  }

  render() {
    const { open, onClose, sending, currency } = this.props
    return (
      <Modal
        isOpened={open}
        onClose={onClose}
        headerTitle="Agregar Ajuste"
        statePath="balance"
        actionType="create"
        typePrefix="BALANCE"
        allowOverflow
      >
        <Form onSubmit={this.handleSubmit}>
          <InputsRow>
            <InputContainer>
              <DatePicker
                name="date"
                label="Fecha"
                disableAfterToday
              />
            </InputContainer>
            <InputContainer>
              <TextInput
                name="total"
                label="Monto"
                prefix={currency && currency.symbol}
                suffix={currency && currency.code}
                type="number"
              />
            </InputContainer>
          </InputsRow>
          <InputContainer fullWidth>
            <TextInput
              name="description"
              label="Concepto"
            />
          </InputContainer>
          <ButtonsRow>
            <Button
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              primary
              type="submit"
              loading={sending}
            >
              Agregar
            </Button>
          </ButtonsRow>
        </Form>
      </Modal>
    )
  }
}


export default AddAdjustmentModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Balance/AddAdjustmentModal.jsx